// React
import { ReactElement } from 'react';
// Next
import { GetServerSideProps, NextPage } from 'next';
import { i18n } from 'next-i18next.config';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
// Context
import { PageProviders } from '@utmb/contexts/index';
// Interfaces
import { HomeView, LangEnum, PageDefaultProps } from '@utmb/types/index';
// Utils
import isMobile from '@utmb/utils/is-mobile';
import { fetchAPI } from '@utmb/utils/utmb';
// Layout
import LayoutRegistration from '@utmb/layouts/my-utmb/LayoutRegistration';
// Features
import { UserInformation } from '@utmb/features/registration-form/user-information/UserInformation';

interface PageProps extends PageDefaultProps, HomeView {}

const IndexMyUtmb: NextPage<PageProps> = ({ event, eventsTopBar, footer, isMobile, mobileBottomBar, navigation, seo, partners, languages }): ReactElement => {
    return (
        <PageProviders>
            <LayoutRegistration
                {...seo}
                isMobile={isMobile}
                eventsTopBar={eventsTopBar}
                mobileBottomBar={mobileBottomBar}
                navigation={navigation}
                footer={footer}
                landing={true}
                event={event}
                partners={partners}
                languages={languages}
                menuLogoIsDark={true}
            >
                <UserInformation />
            </LayoutRegistration>
        </PageProviders>
    );
};

export default IndexMyUtmb;

export const getServerSideProps: GetServerSideProps<HomeView> = async ({ locale, defaultLocale, req }) => {
    try {
        // Translate
        const lang: LangEnum = (locale || defaultLocale || i18n.defaultLocale) as LangEnum;
        const translations = await serverSideTranslations(lang, ['common', 'myutmb']);

        // Page Content
        const page = await fetchAPI(req, '/content/home', { lang });

        // if error
        if (!page) return { notFound: true };
        const { pageHeader, seo, slices } = page;

        return {
            props: {
                isMobile: isMobile(req),
                locale: lang,
                pageHeader,
                seo,
                slices,
                ...translations,
            },
        };
    } catch (error) {
        return {
            notFound: true,
        };
    }
};
